import { Component, OnInit } from "@angular/core";

@Component({
  selector: "evrideo-calendar-icon",
  templateUrl: "./calendar-icon.component.html",
  styleUrls: ["./calendar-icon.component.scss"],
})
export class CalendarIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
